import { render } from "./JudgeWelcome.vue?vue&type=template&id=688d2df8"
import script from "./JudgeWelcome.vue?vue&type=script&lang=js"
export * from "./JudgeWelcome.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__